import http from '../../services/httpService';
import axios from '../../services/httpService';
import { notificationMsg } from '../../utility/Notification';
import {
  GET_USER_PERMISSIONS,
  USER_PROFILE,
  ADD_PM_IN_DIV,
  REV_PM_FROM_DIV,
  ERROR_PM_DIV,
  PROJECTS_TABLE_ERROR,
  LOADING_ACTION,
  RESET_PROJECT_FILTERS,
  SET_PROJECT_FILTER,
  UPDATE_PROJECT_OPTIMISTIC,
  CREATE_PROJECT_OPTIMISTIC,
  ROLLBACK_PROJECT_UPDATE,
} from './Types';
const url = '/division/get';
import { ENV } from '../../configs/appConfig';
import { getProjectManagers } from './user.action';
import { API_URL } from '../../constants/ApiUrls';
import { getEmployees } from './user.action';

const baseUrl = process.env.REACT_APP_API_URL;

export const getDivisions = () => {
  return (dispatch) => {
    http
      .get(url)
      .then((response) => {
        dispatch({
          type: 'GET_ALL_DIVISIONS',
          payload: response?.data.divisions,
        });
      })
      .catch((error) => {
        if (error.response) {
          const { data } = error.response;
          dispatch({
            type: 'ALL_DIVISIONS_FAIL',
            payload: data,
          });
        }
      });
  };
};

export const getAllPM = () => async (dispatch) => {
  const config = {
    method: 'get',
    url: '/division/get',
  };
  try {
    const tempArr = [];
    const res = await axios(config);
    for (let i = 0; i < res?.data?.all_project_managers.length; i++) {
      tempArr.push({
        value: res?.data.all_project_managers[i].id,
        label: res?.data.all_project_managers[i].name,
      });
    }
    dispatch(showLoading(false));
    dispatch({
      type: 'GET_ALL_PM',
      payload: tempArr,
    });
  } catch (error) {
    // will dispatch error message
    dispatch(showLoading(false));
    console.log('pm api error', error);
  }
};

export const getSlackChannels = (request_body) => {
  const url = 'project/slackChannels';
  return (dispatch) => {
    http
      .get(url, { params: request_body })
      .then((response) => {
        dispatch(showLoading(false));
        dispatch({
          type: 'GET_SLACK_CHANNELS',
          payload: response.data,
        });
      })
      .catch((error) => {
        console.log('error =>', error);
        if (error.response) {
          const { data } = error.response;
          dispatch(showLoading(false));
          dispatch({
            type: 'SLACK_CHANNELS_FAIL',
            payload: data,
          });
        }
      });
  };
};

// Add this new action for searching projects
export const searchProjects = (searchQuery, limit = 5) => {
  const url = 'project/search';
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      http
        .get(url, {
          params: {
            q: searchQuery,
            limit: limit,
          },
        })
        .then((response) => {
          dispatch(showLoading(false));
          resolve(response.data);
        })
        .catch((error) => {
          console.log('error =>', error);
          dispatch(showLoading(false));
          reject(error);
        });
    });
  };
};
export const getProjects = (request_body = {}) => {
  const currentPath = window.location.pathname;
  const url = currentPath === '/projects' ? '/project/paginated' : '/project/get';

  if (url == '/project/get') {
    return (dispatch, getState) => {
      // If no filters provided, preserve current filters from Redux state
      const state = getState();
      const currentFilters = state?.projects?.filters || {};

      let mergedFilters;
      if (request_body?.bypass_filters) {
        mergedFilters = {};
      } else {
        mergedFilters = Object.keys(request_body).length > 0 ? request_body : currentFilters;
      }

      http
        .get(url, { params: mergedFilters })
        .then((response) => {
          dispatch(showLoading(false));
          dispatch({
            type: 'GET_PROJECTS',
            payload: response?.data,
          });
          dispatch({ type: GET_USER_PERMISSIONS, payload: response?.data.user });
          dispatch({
            type: 'SET_PROJECT_WITH_EMPLOYEES',
            payload: response?.data?.projects,
          });
        })
        .catch((error) => {
          if (error.response) {
            const { data } = error.response;
            dispatch(showLoading(false));
            dispatch({
              type: 'PROJECTS_FAIL',
              payload: data,
            });
          }
        });
    };
  } else {
    return (dispatch, getState) => {
      // Preserve current filters from Redux state when getProjects is called without filters
      const state = getState();
      const currentFilters = state?.projects?.filters || {};

      // Check if request_body has any filter properties (not just pagination)
      const hasFilterProperties =
        request_body &&
        (request_body.projectName ||
          request_body.managerName ||
          request_body.division ||
          request_body.status ||
          request_body.selectedTeam ||
          request_body.selectedSaleTeamMember ||
          request_body.selectedContract ||
          request_body.selectedCountry ||
          request_body.searchByBillingChannel ||
          request_body.clientName ||
          request_body.engagement ||
          request_body.leadSource ||
          request_body.createdDateRange ||
          request_body.closedDateRange);

      // Merge current filters with provided filters (provided filters take precedence)
      // If only pagination is provided, preserve all other filters
      const filters = hasFilterProperties
        ? { ...currentFilters, ...request_body } // Merge: provided filters override current
        : { ...currentFilters, ...request_body }; // Still merge to include pagination if provided

      // Set default pagination if not provided
      if (!filters.page) {
        filters.page = 1;
      }
      if (!filters.limit) {
        filters.limit = 10;
      }

      // Build query params for API from request_body
      const params = {
        page: Number.parseInt(filters.page) || 1,
        limit: Number.parseInt(filters.limit) || 10,
      };

      // Check if there's any active search (non-empty search)
      // Handle both string search and projectName array
      let hasActiveSearch = false;
      let searchValue = '';

      // Check for direct search string
      if (filters.search && typeof filters.search === 'string' && filters.search.trim() !== '') {
        hasActiveSearch = true;
        searchValue = filters.search.trim();
      }

      // Check for projectName array (from Select component)
      if (filters.projectName && Array.isArray(filters.projectName) && filters.projectName.length > 0) {
        const firstProject = filters.projectName[0];
        if (firstProject && firstProject.value && String(firstProject.value).trim() !== '') {
          hasActiveSearch = true;
          searchValue = String(firstProject.value).trim();
        }
      }

      // Apply default status filters only if no status filter is explicitly provided
      // AND no active search is being performed
      const hasCloseDateFilters = filters.closedFrom || filters.closedTo || (filters.closedDateRange && filters.closedDateRange.length > 0);

      if ((!filters.status || filters.status.length === 0) && !hasActiveSearch && !hasCloseDateFilters) {
        params.statuses = 'ACTIVE,PAUSED,PRESALE';
        console.log('✅ Applying default status filters');
      } else {
        console.log('❌ Not applying default status filters - reason:', {
          hasStatusFilter: Boolean(filters.status && filters.status.length > 0),
          hasActiveSearch: hasActiveSearch,
          hasCloseDateFilters: hasCloseDateFilters,
        });
      }
      // Add filter params if they exist in request_body
      // Handle search parameter properly
      if (searchValue) {
        params.search = searchValue;
      }

      // Handle projectName filter (this is for the search functionality)
      if (filters.projectName && Array.isArray(filters.projectName) && filters.projectName.length > 0 && filters.projectName[0]?.value) {
        // This is already handled by the searchValue above
        // Only set search if not already set from direct search
        if (!params.search) {
          params.search = String(filters.projectName[0].value).trim();
        }
      }

      if (filters.managerName && filters.managerName.length > 0) {
        params.managers = filters.managerName.map((m) => m.value).join(',');
      }

      if (filters.division && filters.division.length > 0) {
        params.divisions = filters.division.map((d) => d.value).join(',');
      }

      // Status filter - will override defaults if explicitly provided
      if (filters.status && filters.status.length > 0) {
        params.statuses = filters.status.map((s) => s.value).join(',');
      }

      if (filters.selectedTeam && filters.selectedTeam.length > 0) {
        params.bdTeams = filters.selectedTeam.map((t) => t.value).join(',');
      }

      if (filters.selectedSaleTeamMember && filters.selectedSaleTeamMember.length > 0) {
        params.bdMembers = filters.selectedSaleTeamMember.map((m) => m.value).join(',');
      }

      if (filters.selectedContract && filters.selectedContract.length > 0) {
        params.contracts = filters.selectedContract.map((c) => c.value).join(',');
      }

      if (filters.selectedCountry && filters.selectedCountry.length > 0) {
        params.countries = filters.selectedCountry.map((c) => c.label).join(',');
      }

      if (filters.searchByBillingChannel && filters.searchByBillingChannel.length > 0) {
        params.billingChannels = filters.searchByBillingChannel.map((b) => b.id).join(',');
      }

      if (filters.clientName && filters.clientName.length > 0) {
        params.clients = filters.clientName.map((c) => c.value).join(',');
      }

      if (filters.engagement && filters.engagement.length > 0) {
        params.engagements = filters.engagement.map((e) => e.value).join(',');
      }

      if (filters.leadSource && filters.leadSource.length > 0) {
        params.leadSources = filters.leadSource.map((l) => l.value).join(',');
      }

      if (filters.startedFrom) params.startedFrom = filters.startedFrom;
      if (filters.startedTo) params.startedTo = filters.startedTo;
      if (filters.closedFrom) params.closedFrom = filters.closedFrom;
      if (filters.closedTo) params.closedTo = filters.closedTo;

      // Add date range filters
      if (filters.createdDateRange && filters.createdDateRange.length > 0) {
        params.startedFrom = filters.createdDateRange[0];
        params.startedTo = filters.createdDateRange[1];
      }

      if (filters.closedDateRange && filters.closedDateRange.length > 0) {
        params.closedFrom = filters.closedDateRange[0];
        params.closedTo = filters.closedDateRange[1];
      }

      console.log('🎯 Final API Params:', params);

      http
        .get(url, { params })
        .then((response) => {
          console.log('✅ API Response received');
          dispatch(showLoading(false));
          dispatch({
            type: 'GET_PROJECTS',
            payload: response?.data,
          });
          dispatch({ type: GET_USER_PERMISSIONS, payload: response?.data.user });
          dispatch({
            type: 'SET_PROJECT_WITH_EMPLOYEES',
            payload: response?.data?.projects,
          });
        })
        .catch((error) => {
          if (error.response) {
            const { data } = error.response;
            dispatch(showLoading(false));
            dispatch({
              type: 'PROJECTS_FAIL',
              payload: data,
            });
          }
        });
    };
  }
};
export const getPaginatedProjects = (filters = {}) => {
  const url = '/project/paginated';

  // Build query params from filters
  const params = {
    page: filters.page || 1,
    limit: filters.limit || 10,
  };

  // Add filter params if they exist
  if (filters.search) params.search = filters.search;
  if (filters.managers && filters.managers.length > 0) {
    params.managers = filters.managers.map((m) => m.value).join(',');
  }
  if (filters.divisions && filters.divisions.length > 0) {
    params.divisions = filters.divisions.map((d) => d.value).join(',');
  }
  if (filters.statuses && filters.statuses.length > 0) {
    params.statuses = filters.statuses.map((s) => s.value).join(',');
  }
  if (filters.bdTeams && filters.bdTeams.length > 0) {
    params.bdTeams = filters.bdTeams.map((t) => t.value).join(',');
  }
  if (filters.bdMembers && filters.bdMembers.length > 0) {
    params.bdMembers = filters.bdMembers.map((m) => m.value).join(',');
  }
  if (filters.contracts && filters.contracts.length > 0) {
    params.contracts = filters.contracts.map((c) => c.value).join(',');
  }
  if (filters.countries && filters.countries.length > 0) {
    params.countries = filters.countries.map((c) => c.value).join(',');
  }
  if (filters.billingChannels && filters.billingChannels.length > 0) {
    params.billingChannels = filters.billingChannels.map((b) => b.id).join(',');
  }
  if (filters.clients && filters.clients.length > 0) {
    params.clients = filters.clients.map((c) => c.value).join(',');
  }
  if (filters.engagements && filters.engagements.length > 0) {
    params.engagements = filters.engagements.map((e) => e.value).join(',');
  }
  if (filters.leadSources && filters.leadSources.length > 0) {
    params.leadSources = filters.leadSources.map((l) => l.value).join(',');
  }
  if (filters.startedFrom) params.startedFrom = filters.startedFrom;
  if (filters.startedTo) params.startedTo = filters.startedTo;
  if (filters.closedFrom) params.closedFrom = filters.closedFrom;
  if (filters.closedTo) params.closedTo = filters.closedTo;

  return (dispatch) => {
    http
      .get(url, { params })
      .then((response) => {
        dispatch(showLoading(false));
        dispatch({
          type: 'GET_PROJECTS',
          payload: response?.data,
        });
        dispatch({ type: GET_USER_PERMISSIONS, payload: response?.data.user });
        dispatch({
          type: 'SET_PROJECT_WITH_EMPLOYEES',
          payload: response?.data?.projects,
        });
      })
      .catch((error) => {
        if (error.response) {
          const { data } = error.response;
          dispatch(showLoading(false));
          dispatch({
            type: 'PROJECTS_FAIL',
            payload: data,
          });
        }
      });
  };
};

export const getProjectsForEmployee = () => async (dispatch) => {
  try {
    const response = await axios.get(`${baseUrl}/employee/getProjectsEmp`);
    if (response.status === 200) {
      dispatch(showLoading(false));
      // dispatch({
      //   type: 'GET_PROJECTS',
      //   payload: response?.data,
      // });
    }
  } catch (e) {
    dispatch(showLoading(false));
    console.log('error is here ====>', e);
  }
};

export const getUserDetail = () => async (dispatch) => {
  const config = {
    method: 'get',
    url: '/employee/getDetails',
  };
  try {
    const response = await axios(config);
    const userEmail = localStorage.getItem('email');
    if (response && response.status === 200) {
      if (!userEmail) {
        localStorage.setItem('email', response.data.user?.email);
        localStorage.setItem('is_admin', response.data.user?.is_admin);
        dispatch({
          type: USER_PROFILE,
          payload: response?.data.user,
        });
      }
      dispatch(showLoading(false));
      dispatch({
        type: 'GET_USER_DETAIL',
        payload: response?.data.details,
        // userProjects: response?.data.projects,
        userRoles: response?.data.roles,
        availableEmployees: response?.data.available_employees,
        nonTechEmployees: response?.data.non_tech_employees,
        projectManagers: response?.data.project_managers,
        sales_teams: response?.data.sales_teams,
      });
    }
  } catch (error) {
    dispatch(showLoading(false));
    console.log('error is here ====>', error);
  }
};

export const addPmInDiv = (request_body) => {
  const url = '/division/addProjectManager';
  return (dispatch) => {
    http
      .post(url, request_body)
      .then((response) => {
        dispatch({
          type: ADD_PM_IN_DIV,
          payload: response.data,
        });
      })
      .catch((error) => {
        if (error.response) {
          const { data } = error.response;
          dispatch({
            type: ERROR_PM_DIV,
            payload: data,
          });
        }
      });
  };
};

export const deleteDivision = (divisionId) => async () => {
  try {
    const response = await axios.delete('/division/delete', { params: { division_id: divisionId } });
    response && response.status === 200 && notificationMsg('Success', 'Division is deleted successfully.');
  } catch (error) {
    notificationMsg('Error', error?.response?.data?.error);
  }
};
export const remPmFromDiv = (divValue, pmId) => async () => {
  try {
    const response = await axios.put('/division/removeProjectManager', { division_id: divValue, project_manager: pmId });
    if (response && response.status === 200) {
      notificationMsg('Success', 'Project manager is deleted successfully.');
    }
  } catch (error) {
    notificationMsg('Error', error?.response?.data?.error);
  }
};
export const showLoading = (status) => {
  return {
    type: LOADING_ACTION,
    payload: status,
  };
};
export const getProjectsError = (errResponse) => (dispatch) => {
  dispatch({
    type: PROJECTS_TABLE_ERROR,
    payload: errResponse,
  });
};
// -------------- project history -------------
export const projectHistory = (id, setAuditLogs, setModal) => async () => {
  const baseUrl = ENV.baseUrl;
  try {
    const endPoint = `${baseUrl}/project/getProjectHistory/${id}?key=${
      location?.pathname === '/csm-client-playbook' ? 'csm-severity-upsell-logs' : 'project-logs'
    }`;
    await axios.get(endPoint).then((response) => {
      setAuditLogs(response?.data.projectHistory);
    });
    setModal(true);
  } catch (error) {
    // notificationMsg('error', error?.response?.data?.error);
  }
};

// ---------- new project create call with optimistic update -------------
export const createProject = (req, nameCreate, setNameCreate, setDivisionCreate, setAddLoader) => async (dispatch, getState) => {
  try {
    if (nameCreate.indexOf(',') != -1) {
      notificationMsg('error', 'Comma operator is not allowed to enter in name.');
    } else {
      const optimisticProject = {
        id: `temp-${Date.now()}`, // Temporary ID
        name: nameCreate,
        division_id: req.division_id,
        status: req.status,
        alreadyOnboarded: true,
        createdAt: new Date().toISOString(),
        Employees: [],
        requestedResourceId: '',
        ProjectDivisions: getState().projects.allDivisions.find((d) => d.id === req.division_id) || null,
      };

      dispatch({
        type: CREATE_PROJECT_OPTIMISTIC,
        payload: optimisticProject,
      });

      const response = await axios.post('/project/create', req);

      if (response && response.status === 201) {
        if (response.data.quickBook) {
          notificationMsg('Success', 'The project and QuickBook customer were successfully onboarded.');
        } else {
          notificationMsg('Success', 'The project was successfully onboarded, but the QuickBook customer was not.');
        }
        setAddLoader(false);
        setNameCreate('');
        setDivisionCreate('');

        dispatch({
          type: UPDATE_PROJECT_OPTIMISTIC,
          payload: {
            projectId: optimisticProject.id,
            updates: { ...response.data.project, id: response.data.project.id },
          },
        });

        const currentProjects = getState().projects.projects;
        const updatedProjects = currentProjects.map((p) => (p.id === optimisticProject.id ? response.data.project : p));
        dispatch({
          type: 'GET_PROJECTS',
          payload: {
            ...getState().projects,
            projects: updatedProjects,
          },
        });
      }
    }
  } catch (error) {
    setAddLoader(false);
    const previousProjects = getState().projects.projects.filter((p) => !p.id.toString().startsWith('temp-'));
    dispatch({
      type: ROLLBACK_PROJECT_UPDATE,
      payload: { previousProjects },
    });
    notificationMsg('error', error?.response?.data?.error);
  }
};

// ---------- new project create call -------------
// export const createProject = (req, nameCreate, setNameCreate, setDivisionCreate, setAddLoader) => async (dispatch) => {
//   try {
//     if (nameCreate.indexOf(',') != -1) {
//       notificationMsg('error', 'Comma operator is not allowed to enter in name.');
//     } else {
//       const response = await axios.post('/project/create', req);
//       dispatch({
//         type: 'CREATE_PROJECT',
//         payload: response.data,
//       });

//       if (response && response.status === 201) {
//         if (response.data.quickBook) {
//           notificationMsg('Success', 'The project and QuickBook customer were successfully onboarded.');
//         } else {
//           notificationMsg('Success', 'The project was successfully onboarded, but the QuickBook customer was not.');
//         }
//         // notificationMsg('success', 'Project is created successfully.');
//         setAddLoader(false);
//         setNameCreate('');
//         setDivisionCreate('');
//         dispatch(getProjects());
//       }
//     }
//   } catch (error) {
//     setAddLoader(false);
//     notificationMsg('error', error?.response?.data?.msg);
//   }
// };

export const createProjectUpdated =
  (data, onOk, setFormData, role, setProjectCategory, archive, setHeading, setLoader, markAsChannel, setDisableButtonLoader) =>
  async (dispatch, getState) => {
    try {
      const isArrayOfObjects = (arr) => arr.every((item) => typeof item === 'object' && !Array.isArray(item));

      const formData =
        data?.projectType === 'INTERNAL_PROJECT'
          ? {
              ...data,
              tech_stack: isArrayOfObjects ? data?.techStack?.map((item) => item?.label) : data?.techStack,
              techStack: isArrayOfObjects ? data?.techStack?.map((item) => item?.label) : data?.techStack,
              projectManagerId: data?.PMAssigned,
            }
          : {
              ...data,
              billing_cycle: data?.billingFrequency || null,
              division_id: data?.divisionId || null,
              tech_stack: isArrayOfObjects ? data?.techStack?.map((item) => item?.label) : data?.techStack,
              techStack: isArrayOfObjects ? data?.techStack?.map((item) => item?.label) : data?.techStack,
              communication: data?.communicationMode,
              bdEmployee: data?.bdPoc,
              projectManagerId: data?.PMAssigned,
              engagement: data?.engagement || data?.augmentation,
              contract:
                data?.introducedAs === 'AGENCY' ? 'AGENCY_TO_CLIENT' : data?.introducedAs === 'INDIVIDUAL_PROFILE' ? 'INDIVIDUAL_TO_CLIENT' : null,
            };

      const optimisticProject = {
        id: `temp-${Date.now()}`,
        ...formData,
        createdAt: new Date().toISOString(),
        Employees: [],
        ProjectDivisions: getState().projects.allDivisions.find((d) => d.id === formData.division_id) || null,
      };

      dispatch({
        type: CREATE_PROJECT_OPTIMISTIC,
        payload: optimisticProject,
      });

      const response = await axios.post('/project/create', formData);
      if (response.status === 201) {
        dispatch({
          type: 'CREATE_PROJECT',
          payload: response.data,
        });
        setLoader(false);
        setDisableButtonLoader(false);
        notificationMsg('success', response.data.message);
        onOk?.();
        setFormData(null);

        const currentProjects = getState().projects.projects;
        const updatedProjects = currentProjects.map((p) =>
          p.id === optimisticProject.id
            ? {
                ...response.data.project,
                manageChannelName: (response?.data?.project?.status + ' ' + response?.data?.project?.name).replaceAll(' ', '-').toLowerCase(),
                internalChannelName: (response?.data?.project?.name + ' internal').replaceAll(' ', '-').toLowerCase(),
              }
            : p,
        );
        dispatch({
          type: 'GET_PROJECTS',
          payload: {
            ...getState().projects,
            projects: updatedProjects,
          },
        });

        dispatch(getSlackChannels());
      }
    } catch (error) {
      setLoader(false);
      const previousProjects = getState().projects.projects.filter((p) => !p.id.toString().startsWith('temp-'));
      dispatch({
        type: ROLLBACK_PROJECT_UPDATE,
        payload: { previousProjects },
      });
      notificationMsg('error', error?.response?.data?.error);
    }
  };

// export const createProjectUpdated =
//   (data, onOk, setFormData, role, setProjectCategory, archive, setHeading, setLoader, markAsChannel, setDisableButtonLoader) => async (dispatch) => {
//     try {
//       const isArrayOfObjects = (arr) => arr.every((item) => typeof item === 'object' && !Array.isArray(item));

//       const formData = data?.projectType === "INTERNAL_PROJECT" ? {
//         ...data,
//         tech_stack: isArrayOfObjects ? data?.techStack?.map((item) => item?.label) : data?.techStack,
//         techStack: isArrayOfObjects ? data?.techStack?.map((item) => item?.label) : data?.techStack,
//         projectManagerId: data?.PMAssigned,
//       } : {
//         ...data,
//         billing_cycle: data?.billingFrequency || null,
//         division_id: data?.divisionId || null,
//         tech_stack: isArrayOfObjects ? data?.techStack?.map((item) => item?.label) : data?.techStack,
//         techStack: isArrayOfObjects ? data?.techStack?.map((item) => item?.label) : data?.techStack,
//         communication: data?.communicationMode,
//         bdEmployee: data?.bdPoc,
//         projectManagerId: data?.PMAssigned,
//         engagement: data?.engagement || data?.augmentation,
//         contract: data?.introducedAs === 'AGENCY' ? 'AGENCY_TO_CLIENT' : data?.introducedAs === 'INDIVIDUAL_PROFILE' ? 'INDIVIDUAL_TO_CLIENT' : null,
//       };

//       const response = await axios.post('/project/create', formData);
//       if (response.status === 201) {
//         dispatch({
//           type: 'CREATE_PROJECT',
//           payload: response.data,
//         });
//         setLoader(false);
//         setDisableButtonLoader(false)
//         notificationMsg('success', response.data.message);
//         // setProjectCategory('');
//         onOk?.();
//         setFormData(null);
//         dispatch(getProjects());
//         dispatch(getSlackChannels());
//       }
//     } catch (error) {
//       setLoader(false);
//       notificationMsg('error', error?.response?.data?.error);
//     }
//   };

// --------------- update project with optimistic updates ------------------
export const updateProject =
  (location, project_id, type, value, old_value, reason, dispatch, roles, projectManagerId, setEditable, billingChannelId) =>
  async (dispatch, getState) => {
    return new Promise(async (resolve, reject) => {
      const previousProjects = [...getState().projects.projects];

      try {
        const updates = {};
        if (type === 'division_id') {
          updates.division_id = value;
          const division = getState().projects.allDivisions.find((d) => d.id === value);
          if (division) updates.ProjectDivisions = division;
        } else if (type === 'status') {
          updates.status = value;
        } else if (type === 'name') {
          updates.name = value;
        } else if (type === 'billingChannel') {
          updates.billingChannelId = billingChannelId;
          const channel = getState().billingChannelReducer?.allBillingChannels?.find((c) => c.id === billingChannelId);
          if (channel) updates.billingChannel = channel.slug;
        } else if (type === 'clientContactPersonName') {
          updates.clientContactPersonName = value;
        } else if (type === 'contract') {
          updates.contract = value;
        } else if (type === 'engagement') {
          updates.engagement = value;
        } else if (type === 'country') {
          updates.country = value;
        } else if (type === 'source') {
          updates.source = value;
        } else if (type === 'billing_cycle') {
          updates.billing_cycle = value;
        } else if (type === 'billingProfile') {
          updates.billingProfile = value;
        } else {
          updates[type] = value;
        }

        dispatch({
          type: UPDATE_PROJECT_OPTIMISTIC,
          payload: {
            projectId: project_id,
            updates,
          },
        });

        if (type === 'lead_sqa' || type === 'lead_developer' || type === 'main_developer') {
          if (old_value) {
            let role = {};
            if (type === 'sales_team') {
              role = roles.find((role) => role.name.toLowerCase() === 'key account handler');
            }
            const request_body = {
              project_id,
              employee_id: old_value,
              reason_for_leaving: reason,
              reportedBy: Number(localStorage.getItem('loggedInUser')),
              projectManagerId,
              role_id: role?.id,
            };
            await axios.post('/project/removeEmployee', request_body);
          }
        }
        if (type === 'project_manager') {
          const role_to_update = roles.find((role) => role.name.toLowerCase() === 'project manager');
          const request_body = {
            project_id,
            employee_id: value,
            role_id: role_to_update ? role_to_update.id : null,
            actionBy: Number(localStorage.getItem('loggedInUser')),
            action: 'create',
            projectManagerId,
            location,
          };

          if (value && value !== 'N/A') {
            await axios.post('/project/addEmployee', request_body);
            dispatch({
              type: UPDATE_PROJECT_OPTIMISTIC,
              payload: {
                projectId: project_id,
                updates: { projectManagerId: request_body.employee_id },
              },
            });
          }
        } else if (type === 'lead_sqa') {
          const role_to_update = roles.filter((role) => role.name === 'SQA Lead');
          const request_body = {
            project_id,
            employee_id: value,
            role_id: role_to_update.length !== 0 ? role_to_update[0]['id'] : null,
            location,
          };
          value !== 'N/A' && (await axios.post('/project/addEmployee', request_body));
        } else if (type === 'lead_developer') {
          if (old_value) {
            const role_to_update = roles.filter((role) => role.name === 'Lead Developer');
            const request_body = {
              project_id,
              employee_id: value,
              role_id: role_to_update.length !== 0 ? role_to_update[0]['id'] : null,
            };
            value !== 'N/A' && (await axios.post('/project/addEmploye', request_body));
          }
        } else if (type === 'sales_team') {
          const role_to_update = roles.find((role) => role.name.toLowerCase() === 'key account handler');
          const request_body = {
            actionBy: Number(localStorage.getItem('loggedInUser')),
            action: 'create',
            projectManagerId,
            project_id,
            employee_id: value,
            role_id: role_to_update ? role_to_update.id : null,
            location,
          };
          value !== 'N/A' && (await axios.post('/project/addEmployee', request_body));
        } else if (type === 'main_developer') {
          const role_to_update = roles.filter((role) => role.name === 'Main SW Engineer');
          const request_body = {
            project_id,
            employee_id: value,
            role_id: role_to_update.length !== 0 ? role_to_update[0]['id'] : null,
            location,
          };
          value !== 'N/A' && (await axios.post('/project/addEmployee', request_body));
        } else {
          const request_body =
            type === 'billingChannel'
              ? { project_id, location: '/projects', billingChannelId }
              : { project_id, [type]: value, location: '/projects' };
          // const request_body = { project_id, [type]: value, location: '/projects'};
          if (type === 'clientContactPersonName') {
            request_body.exactClientName = value;
          }
          // if (type === 'billingChannel') {
          //   request_body.billingChannelId = billingChannelId
          // }
          const response = await axios.put('/project/update', request_body);
        }
        // Only refresh project managers if needed
        if (type === 'project_manager') {
          dispatch(getProjectManagers());
        }
        if (type === 'billingProfile') {
          setEditable(false);
        }
        notificationMsg('success', 'Updated Successfully.');
        if (location === '/home' && type != 'name' && type != 'description') {
          dispatch(getUserDetail());
        }
        resolve(true);
      } catch (e) {
        dispatch({
          type: ROLLBACK_PROJECT_UPDATE,
          payload: { previousProjects },
        });
        notificationMsg?.('error', e?.response?.data?.error);
        reject(false);
      }
    });
  };

// --------- API for status update with reason (optimistic)
export const updateStatusChanged = (project_id, status, location, statusChangeReason) => async (dispatch, getState) => {
  const previousProjects = [...getState().projects.projects];
  try {
    dispatch({
      type: UPDATE_PROJECT_OPTIMISTIC,
      payload: {
        projectId: project_id,
        updates: { status, statusChangeReason },
      },
    });
    const response = await axios.put('/project/update', { project_id, status, location, statusChangeReason });
    dispatch({
      type: 'UPDATE_PROJECT_STATUS',
      payload: response.data,
    });
    if (location === '/home') {
      dispatch(getUserDetail());
    }

    if (response.status === 200) {
      notificationMsg('success', 'Status updated successfully.');
    }
  } catch (e) {
    dispatch({
      type: ROLLBACK_PROJECT_UPDATE,
      payload: { previousProjects },
    });
    notificationMsg('error', e?.response?.data?.error);
  }
};

// ------------ delete project ---------------
export const deleteProject =
  (request_body, setModalConfirm, modalConfirm, setModal, modal, require = true) =>
  async (dispatch) => {
    try {
      await axios.post('/project/delete', request_body).then((res) => {
        if (res.status === 200) {
          setModalConfirm(!modalConfirm);
          setModal(!modal);
          if (require) dispatch(getProjects());
          notificationMsg('success', res.data.message);
          location.pathname = '/projects';
        }
      });
    } catch (e) {
      notificationMsg('error', e.response.data.error);
    }
  };

export const addUpdateEmployee = (visible, setVisible, req) => async (dispatch) => {
  try {
    const response = await axios.post('/project/addEmployee', req);
    if (response && response.status === 200) {
      setVisible(!visible);
      notificationMsg('success', 'Updated successfully.');
      if (location.pathname === '/home') {
        dispatch(getUserDetail());
      } else {
        dispatch(getProjects());
      }
    }
  } catch (error) {
    notificationMsg('error', error?.response?.data?.error);
  }
};

export const getDepartmentsList = (setDepartments, setSubDepartments) => async () => {
  try {
    const resp = await axios(API_URL.GET_DEPARTMENTS);
    const departmentArray = resp?.data?.depts?.map((item) => {
      return { value: item.id, label: item.name, id: item?.HOD?.id, name: item?.HOD?.name, subDepartments: item?.subDepartments };
    });
    setDepartments(departmentArray);
    const subDepartmentArray = resp?.data?.subDepts?.map((item) => {
      return { value: item.id, label: item.name, departmentId: item.departmentId, id: item?.HOD?.id, name: item?.HOD?.name };
    });
    setSubDepartments(subDepartmentArray);
  } catch (error) {
    console.log(error);
  }
};

export const getDivisionsList = (setDivisions) => async () => {
  try {
    const resp = await axios(API_URL.GET_DIVISIONS);
    setDivisions(
      resp?.data?.divisions?.map((item) => {
        return { value: item.id, label: item.name };
      }),
    );
  } catch (error) {
    console.log(error);
  }
};
export const reportManager = (body) => async () => {
  try {
    const response = await axios.post(`project/reportToPM`, body);
    notificationMsg('success', response?.data?.message);
  } catch (error) {
    console.log('====>', error);
    notificationMsg('error', error?.response?.data?.error);
  }
};

export const createProjectSlackChannel = async (projectId) => {
  try {
    const response = await axios.post(`project/create-project-slack-channel/${projectId}`);
    notificationMsg('success', 'Slack channel created successfully');
  } catch (error) {
    const message = error?.response?.data?.error == 'An API error occurred: name_taken' ? 'Channel Already Exists' : error?.response?.data?.error;
    notificationMsg('error', message);
  }
};

// --------------Add Missing Project ----------
export const missingProject = (body) => async () => {
  try {
    const response = await axios.post(`project/addMissingProject`, body);
    notificationMsg('success', response?.data?.message);
  } catch (error) {
    if (error?.response?.data?.status === 404) {
      notificationMsg('error', error?.response?.data?.message);
    }
    if (error?.response?.data?.status === 400) {
      notificationMsg('error', error?.response?.data?.message);
    }
    notificationMsg('error', error?.response?.data?.error);
  }
};

// --------------Add Missing Project ----------
export const addResourceInProject = (body) => async (dispatch) => {
  try {
    const response = await axios.post(`project/addEmployee`, body);
    if (response?.status === 200) {
      dispatch(getUserDetail());
      notificationMsg('success', response?.data?.message);
    }
  } catch (error) {
    notificationMsg('error', error?.response?.data?.error);
  }
};
// -------------- Project timeline -------------
export const getProjectTimeline = (id) => async (dispatch) => {
  try {
    const response = await axios.get(`/projectTimelines/getProjectTimelines`, {
      params: { projectId: id },
    });
    dispatch({
      type: 'SET_PROJECT_TIMELINE',
      payload: response?.data,
    });
  } catch (error) {
    // notificationMsg('error', error?.response?.data?.error);
  }
};

// -------------- Project Detail -------------
export const getProjectDetails = (id) => async (dispatch) => {
  try {
    const response = await axios.get(`/project/getProjectDetail/${id}`, {
      params: { projectId: id },
    });
    dispatch({
      type: 'SET_PROJECT_DETAIL',
      payload: response?.data,
    });
  } catch (error) {
    // notificationMsg('error', error?.response?.data?.error);
  }
};

// ------------ Project Filter ----------------
export const setFilter = (data) => (dispatch) => {
  dispatch({
    type: SET_PROJECT_FILTER,
    payload: data,
  });
};

export const resetFilters = () => (dispatch) => {
  dispatch({
    type: RESET_PROJECT_FILTERS,
  });
};

/*Define the request for generte the billing thread*/
export const generateBillingThread = (request_body, openThreadModel, setOpenThreadModel) => async (dispatch) => {
  try {
    const res = await axios.post('/project/createThread', request_body);
    if (res.status && res.status === 200) {
      if (openThreadModel) {
        setOpenThreadModel(!openThreadModel);
      }
      notificationMsg('success', res.data.message);
      return res;
    } else {
      notificationMsg('error', res.data.message);
    }
  } catch (error) {
    notificationMsg('error', error?.response?.data?.error);
  }
};

export const editEngagementModeAction = (setEditEngagementMode, editEngagementMode) => async (dispatch) => {
  try {
    await axios.put(`/project/${editEngagementMode.id}/updateEmployee/${editEngagementMode.employeeId}`, {
      engagementMode: editEngagementMode.value,
    });
    notificationMsg('success', 'Engagement mode updated successfully.');
    setEditEngagementMode(null);
    dispatch(getEmployees());
  } catch (error) {
    console.log('error =>>', error);
    notificationMsg('error', error?.response?.data?.error);
    setEditEngagementMode(null);
  }
};

export const editEngagementCapacityAction = (setEditEngagementCapacity, editEngagementCapacity) => async (dispatch) => {
  try {
    await axios.put(`/project/${editEngagementCapacity.id}/updateEmployee/${editEngagementCapacity.employeeId}`, {
      engagementCapacity: editEngagementCapacity.value,
    });
    notificationMsg('success', 'Engagement Capacity updated successfully.');
    setEditEngagementCapacity(null);
    dispatch(getEmployees());
  } catch (error) {
    console.log('error =>>', error);
    notificationMsg('error', error?.response?.data?.error);
    setEditEngagementCapacity(null);
  }
};

export const editRoleAction = (setEditRole, editRole) => async (dispatch) => {
  try {
    await axios.put(`/project/${editRole.id}/updateEmployee/${editRole.employeeId}`, {
      role_id: editRole.value,
    });
    notificationMsg('success', 'Role updated successfully.');
    setEditRole(null);
    dispatch(getEmployees());
  } catch (error) {
    console.log('error =>>', error);
    notificationMsg('error', error?.response?.data?.error);
    setEditRole(null);
  }
};

export const editMockNameAction = (setAlias, Alias) => async (dispatch) => {
  try {
    await axios.put(`/project/${Alias.id}/updateEmployee/${Alias.employeeId}`, {
      mock_name: Alias.value,
    });
    notificationMsg('success', 'Alias updated successfully.');
    setAlias(null);
    dispatch(getEmployees());
  } catch (error) {
    console.log('error =>>', error);
    notificationMsg('error', error?.response?.data?.error);
    setAlias(null);
  }
};

export const editRateAction = (setEditRate, editRate, rate) => async (dispatch) => {
  try {
    await axios.put(`/project/${editRate.id}/updateEmployee/${editRate.employeeId}`, { rate });
    notificationMsg('success', 'Resource rate updated successfully.');
    setEditRate(null);
    dispatch(getEmployees());
  } catch (error) {
    console.log('error =>>', error);
    notificationMsg('error', error?.response?.data?.error);
    setEditRate(null);
  }
};

export const updateMilstone = (body, setEditable, setOpenMileStoneUpdate, setUpdateMilestonesReasonModal) => async () => {
  try {
    const res = await axios.put('/project/updateMileStone', body);
    if (res.status === 200) {
      notificationMsg('success', 'Milestone updated successfully');
      setEditable && setEditable(false);
      setOpenMileStoneUpdate && setOpenMileStoneUpdate(false);
      setUpdateMilestonesReasonModal && setUpdateMilestonesReasonModal(false);
    }
    return res;
  } catch (e) {
    console.log('e=> ', e);
    notificationMsg('error', e?.response?.data?.error);
  }
};

export const getEmployeesTimeLogs = (id) => async (dispatch) => {
  try {
    const response = await axios.get(`${baseUrl}/project/projectsTimeLogs`, {
      params: { employeeId: id },
    });
    if (response.status === 200) {
      dispatch({
        type: 'GET_ALL_TIME_LOGS',
        payload: response?.data,
      });
    }
  } catch (e) {
    console.log('error ', e);
    notificationMsg('error', e?.response?.data?.error);
  }
};
export const getProjectsTimeLogs = (id) => async (dispatch) => {
  try {
    const response = await axios.get(`${baseUrl}/project/projectsTimeLogs`, {
      params: { projectId: id },
    });
    if (response.status === 200) {
      dispatch({
        type: 'GET_ALL_PROJECT_TIME_LOGS',
        payload: response?.data,
      });
    }
  } catch (e) {
    console.log('error ', e);
    notificationMsg('error', e?.response?.data?.error);
  }
};
export const createNewMilestone = (body) => async (dispatch) => {
  try {
    const response = await axios.put(`${baseUrl}/project/createMileStone`, body);
    if (response.status === 200) {
      notificationMsg('success', 'New milestone added successfully');
    }
  } catch (e) {
    console.log('error', e);
    notificationMsg('error', e?.response?.data?.error);
  }
};

export const deleteMilestone = (body) => async (dispatch) => {
  try {
    const response = await axios.put(`${baseUrl}/project/deleteMileStone`, body);
    if (response.status === 200) {
      notificationMsg('success', 'Milestone deleted successfully');
    }
  } catch (e) {
    console.log('error', e);
    notificationMsg('error', e?.response?.data?.error);
  }
};

export const getQBCustomers = (request_body) => {
  const url = 'project/qbCustomers';
  return (dispatch) => {
    http
      .get(url, { params: request_body })
      .then((response) => {
        dispatch(showLoading(false));
        dispatch({
          type: 'GET_QB_CUSTOMERS',
          payload: response.data,
        });
      })
      .catch((error) => {
        console.log('error =>', error);
        if (error.response) {
          const { data } = error.response;
          dispatch(showLoading(false));
          dispatch({
            type: 'QB_CUSTOMERS_FAIL',
            payload: data,
          });
        }
      });
  };
};

export const saveQBCustomers = (customerId, projectId) => {
  const url = 'project/saveQBCustomers';
  return (dispatch, getState) => {
    const previousProjects = [...getState().projects.projects];

    dispatch({
      type: UPDATE_PROJECT_OPTIMISTIC,
      payload: {
        projectId,
        updates: { qbCustomerId: customerId },
      },
    });

    http
      .post(url, { customerId, projectId })
      .then(async (response) => {
        dispatch(showLoading(false));
      })
      .catch((error) => {
        dispatch({
          type: ROLLBACK_PROJECT_UPDATE,
          payload: { previousProjects },
        });
        if (error.response) {
          const { data } = error.response;
          dispatch(showLoading(false));
        }
      });
  };
};

export const updateReminderTime = (project_id, remindersTime) => async (dispatch, getState) => {
  const previousProjects = [...getState().projects.projects];

  let oldRemindersTime = {};
  oldRemindersTime = getState().projects.projects?.find((k) => k.id == project_id)?.remindersTime;

  try {
    if (remindersTime?.field == 'dayStart')
      dispatch({
        type: UPDATE_PROJECT_OPTIMISTIC,
        payload: {
          projectId: project_id,
          updates: { remindersTime: { ...oldRemindersTime, dayStart: remindersTime?.value } },
        },
      });
    else
      dispatch({
        type: UPDATE_PROJECT_OPTIMISTIC,
        payload: {
          projectId: project_id,
          updates: { remindersTime: { ...oldRemindersTime, dayEnd: remindersTime?.value } },
        },
      });

    const body = { project_id, remindersTime };
    const response = await axios.put(`${baseUrl}/project/update`, body);
    if (response.status === 200) {
      notificationMsg('success', 'Status updated successfully.');
    }
  } catch (e) {
    dispatch({
      type: ROLLBACK_PROJECT_UPDATE,
      payload: { previousProjects },
    });
    notificationMsg('error', e?.response?.data?.error);
  }
};
export const downloadMonthBasedCSVProjectsData = (body) => async (dispatch) => {
  try {
    const response = await axios.get(`${baseUrl}/project/csvForMonth`, {
      params: body,
    });
    if (response.status === 200) {
      dispatch({
        type: 'GET_MONTH_BASED_CSV_PROJECTS_DATA',
        payload: response?.data,
      });
      notificationMsg('success', 'CSV generated successfully');
    }
  } catch (e) {
    console.log('error', e);
    notificationMsg('error', e?.response?.data?.error);
  }
};
